/**
 * String enum representing programming languages supported by Papyros
 */
export enum ProgrammingLanguage {
    Python = "Python",
    JavaScript = "JavaScript"
}
